import { SelectCards } from 'components/Form/SelectCards';
import 'twin.macro';
import { StepWrapper } from 'containers/Demarrage/components/StepWrapper';
import { replaceItemAtIndex } from 'utils/listMethods';
import { getAllWorkingDaysOptions } from 'components/WorkingDaysSelector';
import { useUpdateDemarrage } from 'containers/Demarrage/queries/useUpdateDemarrage';
import { useDemarrage } from 'containers/Demarrage/queries/useDemarrage';
import _isEmpty from 'lodash-es/isEmpty';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';
import { getDefaultWorkingDays } from 'containers/useCountries';

export function WorkingDays() {
  const update = useUpdateDemarrage();
  const { locale } = useUser();
  const { t } = useTranslation(['onboarding']);
  const { data: demarrageData } = useDemarrage();
  if (!demarrageData) {
    return null;
  }
  const classrooms = demarrageData?.degreesWithWorkingDays || [];

  const defaultWorkingDays = getDefaultWorkingDays(
    demarrageData.userCountryCode,
  );

  return (
    <StepWrapper
      title={t('onboarding:workingDays.title', {
        count: (classrooms || []).length,
      })}
      currentStep="jours-travailles"
      nextDisabled={classrooms.some(c => _isEmpty(c.workingDays))}
    >
      <div tw="space-y-6">
        {classrooms?.map((c, i) => {
          const workingDays = c.workingDays || defaultWorkingDays;
          const sundayStart = workingDays.includes(-1);
          const workingDaysOptions = getAllWorkingDaysOptions(
            sundayStart,
            locale,
            'EEEEEE',
          ).map(o => ({
            description: o.label,
            value: o.value,
          }));

          return (
            <div key={c.degree}>
              <div tw="mb-2 text-xl font-bold">{c.degree}</div>
              <div tw="mb-2">
                <SelectCards<number, true>
                  id={c.degree}
                  value={workingDays}
                  onChange={async v => {
                    await update({
                      degreesWithWorkingDays: replaceItemAtIndex(
                        classrooms,
                        { ...c, workingDays: v },
                        i,
                      ),
                    });
                  }}
                  options={workingDaysOptions}
                  spacing="medium"
                  isMulti
                />
              </div>
            </div>
          );
        })}
      </div>
    </StepWrapper>
  );
}
